/**
 * Password Service
 *
 * Handles password management operations
 */

import { BaseService } from "../base/BaseService";
import {
  PasswordValidation,
  PasswordExpiryInfo,
  ChangePasswordResponse,
  ForcePasswordChangeResponse,
  UpdatePasswordExpirySettingsResponse,
} from "./types";

const AUTH_SERVICE_URL = "auth";

/**
 * Password Service
 * Handles all password-related operations
 */
export class PasswordService extends BaseService {
  constructor() {
    super(AUTH_SERVICE_URL);
  }

  /**
   * Change password
   * POST /password/change
   */
  changePassword(
    userId: string,
    oldPassword: string,
    newPassword: string
  ): Promise<ChangePasswordResponse> {
    return this.post("/password/change", { userId, oldPassword, newPassword });
  }

  /**
   * Validate password strength
   * POST /password/validate
   */
  validatePassword(password: string): Promise<PasswordValidation> {
    return this.post("/password/validate", { password });
  }

  /**
   * Check password expiry
   * GET /password/expiry/:userId
   */
  checkPasswordExpiry(userId: string): Promise<PasswordExpiryInfo> {
    return this.get(`/password/expiry/${userId}`);
  }

  /**
   * Force password change (admin only)
   * POST /password/force-change
   */
  forcePasswordChange(userId: string, targetUserId: string): Promise<ForcePasswordChangeResponse> {
    return this.post("/password/force-change", { userId, targetUserId });
  }

  /**
   * Update password expiry settings
   * PUT /password/expiry-settings/:userId
   */
  updatePasswordExpirySettings(
    userId: string,
    enabled: boolean,
    expiryDays: number
  ): Promise<UpdatePasswordExpirySettingsResponse> {
    return this.put(`/password/expiry-settings/${userId}`, { enabled, expiryDays });
  }
}
